module.exports = {
  HealthTask: 'https://record.iboohee.cn/',
  ExerciseCheck: 'https://nice.iboohee.cn/',
  AlibabaExerciseCheck: 'https://cube.iboohee.cn/',
  Lottery: 'https://one.iboohee.cn',
  Columbus: 'https://columbus.iboohee.cn',
  Passport: 'https://passport.iboohee.cn',
  Bingo: 'https://bingo.iboohee.cn',
  Status: 'https://status.iboohee.cn',
  qiniu_host: 'https://qa.boohee.cn/',
  Crm: 'https://crm.iboohee.cn/',
  League: 'https://league.iboohee.cn/',
  Longan: 'https://longan.iboohee.cn/',
  CONFIG_WATER: {
    app_key: 'b14294453777861d3b42d305',
    app_secret: '79e9371c537eb479da10a2f0734deaf6',
    host: 'https://water.iboohee.cn/'
  },
  CALORY_HOST: 'https://calory.iboohee.cn/',
  PIXIU_HOST: 'https://pixiu.iboohee.cn/',
  FOODIE_HOST: 'https://foodie.iboohee.cn/',
  SA_SERVER_URL: 'https://saapi.boohee.cn/sa?project=default',
  SEAFARER_HOST: 'https://seafarer.iboohee.cn',
  GENE_BIND: 'https://healthy.iboohee.cn',
  TRUCK_HOST: 'https://truck.iboohee.cn/',
  Bee: 'https://bee.iboohee.cn/',
  APPInterface: 'https://api.iboohee.cn/app-interface/',
  DataInterface: 'https://api.iboohee.cn/data-interface/',
  Gpt: 'http://127.0.0.1:3000/',
  LLM: 'http://127.0.0.1:3001',
  BOX_CRON: 'http://127.0.0.1:3000',
  MEMBER_HOST: 'https://member.iboohee.com/',
  api: 'https://api.iboohee.com',
  REPORT_URL: 'https://api.iboohee.com/open-interface/v1/base/front-log-report'
};
